<script setup>
import {computed} from 'vue'
import {useUserStore} from '@/stores/user'

const props = defineProps({
    item: Object
})

const userStore = useUserStore()

const hasAccess = computed(() => !!userStore.access('product_variables'))

const onClick = () => {
    window.location = '/#/product_variables?optionId=' + props.item.id
}
</script>

<template>
    <button v-if="hasAccess" class="btn btn-light btn-sm" type="button" @click="onClick">
        View variables
    </button>
</template>